/**
 * TriggerClick.ts
 *
 * Waits til page si loaded and triggers click event of given selctor
 */
export default class TriggerClick {
    constructor(selector) {
        this.selector = selector;
        this.waitForDomReady(() => this.trigger());
    }
    waitForDomReady(callback) {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            // DOM loaded
            callback();
        }
        else {
            document.addEventListener('DOMContentLoaded', callback);
        }
    }
    trigger() {
        const element = document.querySelector(this.selector);
        if (!element) {
            console.warn(`TriggerClick: Element mit Selector '${this.selector}' nicht gefunden.`);
            return;
        }
        try {
            // Event erzeugen
            const event = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            });
            element.dispatchEvent(event);
        }
        catch (error) {
            console.error('TriggerClick: Fehler beim Auslösen des Click-Events', error);
        }
    }
}
// examle:
// new TriggerClick('#captcha__reload');
